<template>
  <div class="animated fadeIn">
    <div class="row pageinfo">
      <b-col lg="6">
        <!--Display Trash or Normal Table View-->
        <h2 v-show="!trash">Report</h2>
        <h2 v-show="trash">Report - Trash</h2>
      </b-col>
    </div>

    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid terminal>
            <!-- Main table element -->
            <b-row class="justify-content-between">
              <b-col md="4" class="my-1">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <b-form-input v-model="filter" placeholder="Search" />
                    <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" class="my-1">
								<b-dropdown class="pull-left" :text="dpdt">
									<b-dropdown-item @click="trashTerminal()">Active</b-dropdown-item>
									<b-dropdown-item @click="trashTerminal()">Trash</b-dropdown-item>
								</b-dropdown>
							</b-col>
              <b-col lg="5" class="my-1">
                <b-button variant="primary" class="pull-right" @click="newTerminalModal">Add Report</b-button>
              </b-col>
            </b-row>
            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                <p class="text-center">
                  <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                </p>
              </b-col>
            </b-row>
            <!-- End Main table Elements-->
            <b-table v-else striped hover bordered show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered"  @row-clicked="rowClicked">

            </b-table>
            <b-row>
              <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"></div>
                  <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
              <!-- User Interface controls -->

              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- End User Interface controls-->
          </b-container>
        </b-row>
      </div>
    </div>
    <!-- New Terminal Modal-->
    <b-modal title="New Power Bi" size="lg" v-model="newTerminal" ok-only ok-title="Cancel" ok-variant="secundary">
      <b-row>
        <b-col cols="12">
            <b-form-group :label-cols="4" horizontal label="Company Type" label-for="pwbi0">
				      <b-form-select id="pwbi0" value-field="id" text-field="name" v-model="model.company_type_id" :options="company_type" @input="select_company_type()"/>
			      </b-form-group>
        </b-col> 
        <b-col cols="12">
            <b-form-group v-if ="model.company_type_id === 0" :label-cols="4" horizontal label="Energy Companies" label-for="pwbi1">
				      <b-form-select id="pwbi1" value-field="id" text-field="name" v-model="model.company_id" :options="company_name" @input="select_company()">
                <template slot="first"><option :value="null" disabled>-- select energy company --</option></template>
              </b-form-select>
			      </b-form-group>
            <b-form-group v-else :label-cols="4" horizontal label="Trucking Companies" label-for="pwbi1">
				      <b-form-select id="pwbi1" value-field="id" text-field="name" v-model="model.company_id" :options="company_name" @input="select_company()">
                <template slot="first"><option :value="null" disabled>-- select trucking company --</option></template>
              </b-form-select> 
			      </b-form-group>
      			<b-form-group :label-cols="4" id="L0" label="Report Name" label-for="pwb3" horizontal>
				      <b-form-input id="pwb3" v-model="model.report_name" type="text" placeholder="Report Name"></b-form-input>
		      	</b-form-group>
            <b-form-group :label-cols="4" id="L17" label="Activate Power Bi" label-for="ULID" horizontal>
							<b-form-checkbox 
                id="ULID"
								class="custom-checkboxes"
                v-model="model.activate_pb" 
							  style="margin-top: 13px;"
              ></b-form-checkbox>	
					  </b-form-group>	
            <b-form-group v-if ="!model.activate_pb" :label-cols="4" id="L1" label="Pdf File" label-for="pwb2" horizontal>
				      <input type="file" id="files" accept="application/pdf" ref="file" v-on:change="handleFileUpload()" />
			      </b-form-group>
            <b-form-group v-if ="model.activate_pb" :label-cols="4" id="L2" label="Url" label-for="pwb3" horizontal>
				      <b-form-input id="pwb3" v-model="model.url" type="url" placeholder="Url"></b-form-input>
			      </b-form-group>
        </b-col> 
    </b-row>
    <b-row v-if="progress">
                    <b-col v-if="load_pdf==='Saving PDF file.....'" md="10">
                        <h5 class="mt-3" > <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i> {{load_pdf }}</h5>
                        <b-progress :value="uploadPercentage" :max="100" show-progress animated class="mb-3"></b-progress>
                    </b-col>
                    <b-col v-else md="10">
                        <h5 class="mt-3" >{{load_pdf }}</h5>
                        <b-progress :value="uploadPercentage" :max="100" show-progress animated class="mb-3"></b-progress>
                    </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
              <b-embed v-if="url!=''"
                type="iframe"
                aspect="16by9"
                allowfullscreen
                frameborder="0"
                :src=url
            ></b-embed>
        </b-col> 
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="newTerminal=false" class="float-left">Cancel</b-btn>
        <b-button :disabled="savebtn" size="md" variant="primary" @click="saveReport" class="float-right">Save</b-button>
      </div>
    </b-modal>
    <!-- End New Terminal Modal-->
    </div>
</template>

<script>
  import Vue from 'vue'
  import pwbi_service from './pwbi_service'
  import axios from 'axios'
  import {apiDomain} from '../../config'

  const items = []
  export default {
    name: 'PowerBis',
    created: function() {
      this.getAll()
    },
    data() {
      return {
        trash           : false,
        dpdt            : 'Active',
        model           : {
          company_type_id : 0,
          company_id      : null,
          company_name    : '',
          report_name     : '',
          activate_pb     : true,
          url             : '',
          pdf             : '',
        },
        newTerminal     : false,
        items           : items,
        fields          : [
          {
            key         : 'id',
            label       : 'ID',
            sortable    : true
          },
          {
            key         : 'company_type',
            label       : 'Company Type',
            sortable    : true
          },
          {
            key         : 'company_name',
            label       : 'Company Name',
            sortable    : true
          },
          {
            key         : 'report_name',
            label       : 'Report Name',
            sortable    : true
          }
        ],
        currentPage     : 1,
        perPage         : 25,
        totalRows       : items.length,
        pageOptions     : [25, 50, 100],
        sortBy          : 'name',
        sortDesc        : false,
        filter          : null,
        loadingData     : true,
        savebtn         : true,
        company_type    : [],
        company_name    : [],
        energies_companies : [],
        role            : '',
        file            : '',
        next            : '',
        url             : '',
        load_pdf        : 'Saving PDF file.....',
        uploadPercentage: 0,
        progress        : false
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })
      }
    },
    methods: {
      handleFileUpload() {
        this.file = this.$refs.file.files[0]
        this.model.pdf = this.file['name']
        let url = window.URL.createObjectURL(this.file)
        this.url = url
				setTimeout(() => window.URL.revokeObjectURL(url), 100)
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      newTerminalModal() {
        this.model.company_type_id  = 0
        this.model.company_id       = null
        this.model.company_name     = ''
        this.model.activate_pb      = true
        this.model.url              = ''
        this.model.pdf              = ''
        this.model.report_name      = ''
        this.url                    = ''
        this.company_name           = this.energies_companies
        this.savebtn                = false
        this.newTerminal            = true
        this.progress               = false 
      },
      trashTerminal() {
				this.trash = !this.trash
				this.dpdt = this.trash ? "Trash" : "Active"
				this.getAll()
				this.loadingData = true
			},
      rowClicked(row) {
				if(!this.trash) {
					this.$router.push('/powerbi/' + row.id + '/')
				} else {
					this.restoreTerminal(row.id)
				}
      },
    okToSave() {
				if (this.model.company_id  === undefined || this.model.company_id == null) {
					this.$swal('Alert!', 'Select Company', 'warning')
					return false
				} else if (this.model.company_name  === undefined || this.model.company_name === '') {
					this.$swal('Alert!', 'Select Company', 'warning')
					return false
				} else if (this.model.report_name === '' || this.model.report_name === null) {
					this.$swal('Alert!', 'Please, Enter Report Name', 'warning')
					return false
        }
        
        if (this.model.activate_pb) {
          if (this.model.url === '') {
					  this.$swal('Alert!', 'Please, Enter Url', 'warning')
					  return false
				  }
				} else {
          if (this.model.pdf === '') {
					  this.$swal('Alert!', 'Please, Enter Pdf file', 'warning')
					  return false
				  }          
        }
				return true
	},
    saveReport () {
        if (!this.okToSave()) {
		    return
        }  
        this.savebtn                = true
        const json = JSON.stringify(this.model);
        const blob = new Blob([json], {
          type: 'application/json'
        })
        let formData = new FormData()
        formData.append("document", blob)
        formData.append('file', this.file)
        this.uploadPercentage   = 0
        if (!this.model.activate_pb) {
          this.progress           = true 
        }     
        this.load_pdf           = 'Saving PDF file.....'
        this.save_pdf ( formData )
        //pwbi_service.save_pdf(formData)
         // .then(data1 => {
          //  this.$swal(data1.status, data1.message, data1.status)
           //   if (data1.status=="success") {        
            //    this.newTerminal = false
             //   this.getAll()              
            //  } 
          //})
          //.catch(error => {
           // this.$swal('Error', 'Server not response. ' + error, 'error')
          //}) 
        this.savebtn=false
    },
      getAll() {
        this.loadingData = true
        pwbi_service.getAll()
          .then(data => {
            if (data.status == 'success') {
                if (data.powerbi.length>0) {
                    this.items          = data.powerbi.filter(o => o.status_id == (this.trash ? 2 : 1))           
                } 
                this.company_type         = data.insert_data.pwbi 
                this.energies_companies   = data.insert_data.pwbi[0].energy_companies
                this.role = data.role
                this.loadingData = false
            }else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },      
      select_company_type() {
        if (this.role =='super_admin') {         
            if (this.model.company_type_id === 0) {
                this.company_name  =  this.company_type[0].energy_companies  
                this.model.company_id  = null
            } else {
                this.company_name  =  this.company_type[1].trucking_companies
                this.model.company_id  = null
            }	 
        }
      },
    select_company() {
        if (this.role =='super_admin') {        
            let companies = this.company_name
			let company_index = companies.map(o => o.id).indexOf(this.model.company_id)
			if (company_index > -1) {
			    this.model.company_name = companies[company_index].name
			} else {
                this.model.company_name = ''
			}
        }
    },
      restoreTerminal(id) {
		    this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to restore this Power bi ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
                    reverseButtons: true
				}).then((result) => {
					if (result.value) {
						pwbi_service.restore(id)
							.then(data => {
                this.$swal(data.status, data.message, data.status)
								if (data.message == 'success') {
									this.filter = ''
									this.trash = false
									this.getAll()
									this.loadingData = true
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
      },
      save_pdf ( formData ) {

			  axios.post(apiDomain + '/report/create/', formData, { headers: {
				  'Content-Type': 'multipart/form-data',
			    'token': localStorage.getItem('access_token')
        },
          onUploadProgress: ( progressEvent ) => {
            this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
        }
        })
				  .then((response) => {
            let data = response.data
            if (data.status == 'success') {
              this.load_pdf           = 'PDF file saved'
              this.$swal(data.status, data.message, data.status)
              this.newTerminal = false
              this.getAll() 
            } else {
                this.load_pdf        = 'Saving PDF file.....',
                this.uploadPercentage= 0,
                this.progress        = false
                this.model.pdf       = ''
                this.url             = ''
                this.file            = ''
                this.$swal(data.status, data.message, data.status)
            }
				  })
				  .catch((error) => {
              this.load_pdf        = 'Saving PDF file.....',
              this.uploadPercentage= 0,
              this.progress        = false
              this.$swal('Error', 'Server not response. ' + error, 'error')
				  })
	    },

    }
  }
</script>



// WEBPACK FOOTER //
// src/views/powerbi/pwbi_listing.vue